var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWorkshops2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.9987 1.6665H14.9987C15.9154 1.6665 16.6654 2.4165 16.6654 3.33317V6.93318H3.33203V3.33317C3.33203 2.4165 4.08203 1.6665 4.9987 1.6665Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33203 6.93311V9.89977C3.33203 10.7998 3.81539 11.6331 4.60706 12.0748L7.07369 13.4664C7.59869 13.7581 7.92371 14.3165 7.92371 14.9165V16.6664C7.92371 17.5831 8.67371 18.3331 9.59037 18.3331H10.4237C11.3404 18.3331 12.0904 17.5831 12.0904 16.6664V14.9165C12.0904 14.3165 12.4154 13.7581 12.9404 13.4664L15.407 12.0748C16.1904 11.6331 16.682 10.7998 16.682 9.89977V6.93311H3.33203Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkshops2);
export default __webpack_public_path__ + "static/media/workshops2.4b162b7a4d90d280b1f63176a740d01a.svg";
export { ForwardRef as ReactComponent };